import { render, staticRenderFns } from "./_repullData.vue?vue&type=template&id=6b170b9e&scoped=true&lang=pug&"
import script from "./_repullData.vue?vue&type=script&lang=js&"
export * from "./_repullData.vue?vue&type=script&lang=js&"
import style0 from "./_repullData.vue?vue&type=style&index=0&id=6b170b9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b170b9e",
  null
  
)

export default component.exports